import { useEffect, useRef } from "react";
import styled from "styled-components";
import {
  CompanyTab,
  ProductTab,
  TechnologyTab,
  TeamTab,
  PartnersTab,
  ContactTab,
} from "./tabs";

const Container = styled.div`
  position: fixed;
  width: 100vw;
  top: 80px;
  bottom: 0;
  padding-bottom: 150px;
  z-index: 10;
  align-items: flex-start;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    top: 56px;
  }
`;

const Backdrop = styled.div`
  position: fixed;
  height: 100vh;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.261);
  backdrop-filter: blur(4px);
`;

const Content = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
  z-index: 1;
  padding-top: 40px;
`;

const ContentInner = styled.div`
  width: 100vw;
  height: 100%;
  padding: 24px;
  display: flex;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 16px;
  }
`;

function TabContent({ tab, currentLang }) {
  const containerRef = useRef(null);

  useEffect(() => {
    // Reset scroll position using the container reference
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [tab]);

  if (!tab) return null;

  const renderTabContent = () => {
    switch (tab) {
      case "company":
        return <CompanyTab currentLang={currentLang} />;
      case "product":
        return <ProductTab currentLang={currentLang} />;
      case "technology":
        return <TechnologyTab currentLang={currentLang} />;
      case "team":
        return <TeamTab currentLang={currentLang} />;
      case "partners":
        return <PartnersTab currentLang={currentLang} />;
      case "contact":
        return <ContactTab currentLang={currentLang} />;
      default:
        return null;
    }
  };

  return (
    <Container ref={containerRef}>
      <Backdrop />
      <Content>
        <ContentInner>{renderTabContent()}</ContentInner>
      </Content>
    </Container>
  );
}

export default TabContent;
